export const makeBinaryFromBase64 = async (url: string) => {
	let blob = await fetch(url);
	return blob.blob();
};
